import { LocalStorageKeys } from "@/config/localStorage";

export class LocalStorage {
	static set<K extends LocalStorageKeys, T>(key: K, value: T): void {
		localStorage.setItem(key, JSON.stringify(value));
	}

	static get<K extends LocalStorageKeys, T>(key: K): T | null {
		const item = localStorage.getItem(key);
		return item ? (JSON.parse(item) as T) : null;
	}

	static remove(key: LocalStorageKeys): void {
		localStorage.removeItem(key);
	}

	static clear(): void {
		localStorage.clear();
	}
}
